/**
 * BatchGeoBaseToolbar inits the main BatchGeoToolbar instance. This instance
 * contains the main buttons for the app such as reset, user geolocation, and
 * drawing tools.
 *
 * It takes no arguments or options. It simply returns the proper base instance.
 */
(function () {
  window.BatchGeoBaseToolbar = function () {
    var isMobile = BatchGeoDevices.is("mobile");

    var isAdvanced = function () {
      return BatchGeoStore.getState().App.advanced;
    };

    var isStoreLocatorMode = function () {
      return BatchGeoStore.getState().App.mapMode === "store_locator";
    };

    var activeButtonManager = {
      removeActiveStates: function () {
        $(".drawing-manager-button").removeClass("active");
      },
      addActiveState: function (newMode) {
        $(".drawing-manager-button-" + newMode).addClass("active");
      },
      addButtonClone: function (newMode) {
        var $el = $(".drawing-manager-button-" + newMode).first();
        $el.addClass("active");
        var $buttonGroup = $el.parent();
        $buttonGroup
          .find(".drawing-manager-button")
          .first()
          .replaceWith($el.clone(true));
      },
      addActiveOptionsState: function (newOptionMode, mode, callback) {
        var $el = $(".batchgeo-" + mode + "-options-button-" + newOptionMode);
        $(
          ".drawing-manager-button-" +
            mode +
            " .toolbar-options-button-group button",
        ).removeClass("active");
        $el.addClass("active");

        if (callback) {
          callback(newOptionMode);
        }
      },
      changeToState: function (newMode) {
        this.removeActiveStates();
        this.addActiveState(newMode);
        this.addButtonClone(newMode);
      },
    };
    // BatchGeoStore.addListener("DRAWING_MANAGER_SET_MODE", () => {
    //   console.log("call");
    // });
    // BatchGeoStore.addListener("MARKER_MEASURE_DISABLE", () => {
    //   activeButtonManager.removeActiveStates();
    // });
    BatchGeoStore.addListener(
      function (state) {
        return state.DrawingManager.mode;
      },
      function (nextMode, prevMode) {
        return nextMode !== prevMode;
      },
      function (newMode) {
        var abm = activeButtonManager;
        abm.removeActiveStates();
        abm.addActiveState(newMode);
        BatchGeoStore.dispatch({ type: "MARKER_MEASURE_DISABLE" });
        if (newMode !== "hand") {
          abm.addButtonClone(newMode);
        }
      },
    );

    BatchGeoStore.addListener(
      function (state) {
        return state.MarkerMeasure.enabled;
      },
      function (newEnabled, prevEnabled) {
        return (
          newEnabled !== prevEnabled &&
          !window.batchGeoTableMap.batchGeoTable.options.data.dist_cb_status
        );
      },
      function (enabled) {
        var columnGenerator = window.batchGeoTableMap.distanceColumnGenerator;
        if (enabled) {
          columnGenerator.generateColumn();
        } else {
          columnGenerator.removeColumn();
        }
      },
    );

    var rulerOptions = function () {
      var optionsArray = [
        { text: "km", class: "kilometers" },
        { text: "mi", class: "miles" },
      ];

      return optionsArray.map(function (option) {
        return Object.assign(option, {
          action: function () {
            if (BatchGeoStore.getState().App.units !== option.text) {
              $(".gm-style-cc").click();
            }
          },
        });
      });
    };

    var batchGeoToolbar = new BatchGeoToolbar({
      container: "#mapWrap",
      class: "base-toolbar",
      buttons: function () {
        return [
          {
            "Reset map": {
              icon: "refresh",
              class: "mapReset mapButton",
              action: function (event) {
                window.batchGeoMap.mapReset(event);
              },
            },
          },
          {
            "Find My Location": {
              icon: "location",
              // If we are on mobile we default to an active state since it is
              // turned on automatically
              class: "userLocation" + (isMobile ? " active" : ""),
              //We hide on mobile since mobile has a different UI for this geolocation feature
              visibility: [!isMobile],
              action: function (event) {
                // If we're on mobile we have already started tracking the user's
                // location so we simply update their location. If they have
                // panned or something we stop tracking them so we need to trigger
                // an update on mobile. On desktop it turns it on and off
                // completely.
                var eventType = isMobile ? "ACTIVE_CYCLE" : "ACTIVE_TOGGLE";

                BatchGeoStore.dispatch({
                  type: "USER_LOCATION_" + eventType,
                });

                var state = BatchGeoStore.getState().UserLocation;
                var $thisButton = $(event.currentTarget);
                // toggle doesn't work for mobile + desktop since mobile cycles different states
                if (state.active && !$thisButton.hasClass("active")) {
                  $thisButton.addClass("active");
                } else if (!state.active) {
                  $thisButton.removeClass("active");
                }
              },
            },
          },
          {
            "Move tool": {
              icon: "hand",
              class: "drawing-manager-button drawing-manager-button-hand",
              visibility: [isAdvanced()],
              action: function () {
                BatchGeoStore.dispatch([
                  {
                    type: "MARKER_MEASURE_DISABLE",
                  },
                  {
                    type: "DRAWING_MANAGER_SET_MODE",
                    mode: "hand",
                  },
                ]);

                activeButtonManager.changeToState("hand");
              },
            },
          },
          [
            {
              "Rectangle selection tool": {
                icon: "rectangle",
                class:
                  "drawing-manager-button drawing-manager-button-rectangle has-children",
                visibility: [!isMobile, isAdvanced(), !isStoreLocatorMode()],
                action: function () {
                  BatchGeoStore.dispatch({
                    type: "DRAWING_MANAGER_SET_MODE",
                    mode: "rectangle",
                  });
                },
              },
            },
            {
              "Circle selection tool": {
                icon: "circle",
                class:
                  "drawing-manager-button drawing-manager-button-circle has-children",
                visibility: [!isMobile, isAdvanced(), !isStoreLocatorMode()],
                action: function () {
                  BatchGeoStore.dispatch({
                    type: "DRAWING_MANAGER_SET_MODE",
                    mode: "circle",
                  });
                },
              },
            },
            {
              "Polygon selection tool": {
                icon: "polygon",
                class:
                  "drawing-manager-button drawing-manager-button-polygon has-children",
                visibility: [!isMobile, isAdvanced(), !isStoreLocatorMode()],
                action: function () {
                  BatchGeoStore.dispatch({
                    type: "DRAWING_MANAGER_SET_MODE",
                    mode: "polygon",
                  });
                },
              },
            },
          ],
          [
            {
              "Measuring tool": {
                icon: "ruler",
                class:
                  "drawing-manager-button drawing-manager-button-ruler has-children kilometers",
                visibility: [!isMobile, isAdvanced()],
                action: function () {
                  BatchGeoStore.dispatch({
                    type: "DRAWING_MANAGER_SET_MODE",
                    mode: "ruler",
                  });
                },
                options: rulerOptions(),
              },
            },
            {
              "Marker measure tool": {
                icon: "marker-distance",
                class:
                  "drawing-manager-button drawing-manager-button-marker-distance has-children",
                visibility: [!isMobile, isAdvanced()],
                action: function (event) {
                  var map = window.batchGeoGoogleMapsManager.getMap();

                  // Set the drawing mode to hand to force it out of any drawing
                  // mode the user could be in
                  BatchGeoStore.dispatch({
                    type: "DRAWING_MANAGER_SET_MODE",
                    mode: "hand",
                  });

                  activeButtonManager.changeToState("marker-distance");

                  BatchGeoStore.dispatch({
                    type: "MARKER_MEASURE_SET_POSITION",
                    position: {
                      lat: map.getCenter().lat(),
                      lng: map.getCenter().lng(),
                    },
                  });

                  BatchGeoStore.dispatch({
                    type: "MARKER_MEASURE_ENABLE",
                    // We disable polylines after 500 markers to speed up the
                    // measure process and not to block the map with lines
                    polylineLimit: 500,
                  });

                  $(event.currentTarget).toggleClass(
                    "active",
                    BatchGeoStore.getState().MarkerMeasure.enabled,
                  );
                },
              },
            },
          ],
          {
            Printer: {
              icon: "print",
              class: "printfriendly-button printfriendly-button-printer",
              visibility: [!isMobile],
              action: function printPage() {
                window.batchGeoPrinter.dialog();
              },
            },
          },
        ];
      },
    });

    BatchGeoStore.addListener(
      function (state) {
        return state.App.advanced;
      },
      function (newAdvanced, prevAdvanced) {
        return newAdvanced !== prevAdvanced;
      },
      function () {
        batchGeoToolbar.render();
      },
    );

    // and add the listener for toolbar tooltip actions
    BatchGeoStore.addListener(
      function (state) {
        return state.ToolbarTooltip;
      },
      function (newState, oldState) {
        return !_.isEqual(newState, oldState);
      },
      function (newState) {
        //if user is on mobile
        if (newState.tooltipIsVisible) {
          //show tooltip w/ 3sec timeout
          batchGeoToolbar.showTooltip(newState.tooltipContent);
        } else {
          batchGeoToolbar.hideTooltip();
        }
      },
    );

    var swapUnitsClasses = function () {
      $(".drawing-manager-button-ruler").toggleClass("miles kilometers");
    };

    BatchGeoStore.addListener("App", "units", function (newState) {
      var unitsName = newState.units === "mi" ? "miles" : "kilometers";
      activeButtonManager.addActiveOptionsState(
        unitsName,
        "ruler",
        swapUnitsClasses,
      );
    });

    BatchGeoStore.addListener("UserLocation", "active", (currentState) => {
      $(".base-toolbar .userLocation").toggleClass(
        "active",
        currentState.active,
      );
    });

    return batchGeoToolbar;
  };
})();
